var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowBuyStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "url(#paint0_linear_316_921)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7852 24.5996C43.7852 23.9093 44.3448 23.3496 45.0352 23.3496C48.4922 23.3496 51.2852 26.1426 51.2852 29.5996V35.133C51.2852 35.8233 50.7255 36.383 50.0352 36.383C49.3448 36.383 48.7852 35.8233 48.7852 35.133V29.5996C48.7852 27.5233 47.1115 25.8496 45.0352 25.8496C44.3448 25.8496 43.7852 25.29 43.7852 24.5996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7188 24.5996C20.7188 23.9093 21.2784 23.3496 21.9688 23.3496H37.6521C38.3425 23.3496 38.9021 23.9093 38.9021 24.5996C38.9021 25.29 38.3425 25.8496 37.6521 25.8496H21.9688C21.2784 25.8496 20.7188 25.29 20.7188 24.5996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1193 18.4491C28.6075 18.9373 28.6075 19.7287 28.1193 20.2169L23.7365 24.5996L28.1193 28.9825C28.6075 29.4706 28.6075 30.2621 28.1193 30.7502C27.6311 31.2384 26.8397 31.2384 26.3515 30.7502L21.0849 25.4835C20.8504 25.2491 20.7188 24.9312 20.7188 24.5996C20.7188 24.2681 20.8505 23.9502 21.0849 23.7157L26.3515 18.4491C26.8397 17.961 27.6311 17.961 28.1193 18.4491Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9688 35.6162C22.6591 35.6162 23.2188 36.1759 23.2188 36.8662V42.3995C23.2188 44.4759 24.8924 46.1495 26.9688 46.1495H50.0354C50.7258 46.1495 51.2854 46.7092 51.2854 47.3995C51.2854 48.0899 50.7258 48.6495 50.0354 48.6495H26.9688C23.5117 48.6495 20.7188 45.8565 20.7188 42.3995V36.8662C20.7188 36.1759 21.2784 35.6162 21.9688 35.6162Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8857 41.2489C44.3738 40.7608 45.1652 40.7608 45.6533 41.2489L50.92 46.5156C51.1545 46.7501 51.286 47.0679 51.286 47.3994C51.286 47.7309 51.1545 48.0489 50.92 48.2834L45.6533 53.5499C45.1652 54.0381 44.3738 54.0381 43.8857 53.5499C43.3975 53.0618 43.3975 52.2704 43.8857 51.7823L48.2683 47.3994L43.8857 43.0166C43.3975 42.5284 43.3975 41.7371 43.8857 41.2489Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_921",
    x1: 10.9149,
    y1: -1.86667e-7,
    x2: 71.6748,
    y2: 17.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowBuyStep2);
export default __webpack_public_path__ + "static/media/How-Buy-Step-2.6afff1cf363694743d16248ffb5a8f80.svg";
export { ForwardRef as ReactComponent };